export default "__VITE_ASSET__DyZ8nn7m__"